(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const Play = window.RB.Play;

  const COST_KINDS = {
    discard: {
      canPay(state, p, spec) { return Play.canPayDiscard(state, p, spec.n, spec.type); },
      cands(state, p, spec) { return Play.discardableHand(state, p, spec.type); },
      prompt(state, spec, item, label) {
        return { tag: "discard", prompt: "Discard " + spec.n + (spec.type ? " " + spec.type : "") + " (" + label + ")", min: spec.n, max: spec.n };
      },
      pay(state, p, picks) { Flow.discard(state, p, picks); },
    },
    kill: {
      canPay(state, p, spec) { return Play.addCostKillCands(state, p, spec).length > 0; },
      cands(state, p, spec) { return Play.addCostKillCands(state, p, spec); },
      prompt(state, spec, item, label, cands) {
        return {
          tag: "target", src: item.label,
          prompt: "Kill " + (spec.any ? "any number of friendly units" : "a friendly " + spec.type) + " (" + label + ")",
          min: 1, max: spec.any ? cands.length : 1,
        };
      },
      pay(state, p, picks, spec, item, a, countKey) {
        a[countKey + "Count"] = picks.length;
        a[countKey + "KillCost"] = picks.reduce(function (acc, iid) {
          const cd = Core.card(state, iid);
          return { energy: acc.energy + (cd.energy || 0), power: acc.power + (cd.power || 0) };
        }, { energy: 0, power: 0 });
        if (spec.playToPaidBf) {
          const o = state.objs[picks[0]];
          if (o && o.loc && o.loc.t === "bf") item.addCostBf = { t: "bf", iid: o.loc.iid };
        }
        Flow.killObjs(state, picks, { via: "cost" });
      },
    },
    return: {
      canPay(state, p, spec) { return Play.addCostKillCands(state, p, spec).length > 0; },
      cands(state, p, spec) { return Play.addCostKillCands(state, p, spec); },
      prompt(state, spec, item, label) {
        return { tag: "target", src: item.label, prompt: "Return a friendly " + spec.type + " to its owner's hand (" + label + ")", min: 1, max: 1 };
      },
      pay(state, p, picks) { Flow.toHand(state, picks[0]); },
    },
    exhaust: {
      canPay(state, p) { return Play.friendlyUnits(state, p).some(function (i) { return state.objs[i].ready; }); },
      cands(state, p) { return Play.friendlyUnits(state, p).filter(function (i) { return state.objs[i].ready; }); },
      prompt(state, spec, item, label) {
        return { tag: "target", src: item.label, prompt: "Exhaust a friendly unit (" + label + ")", min: 1, max: 1 };
      },
      pay(state, p, picks) { state.objs[picks[0]].ready = false; },
    },
    spendBuff: {
      canPay(state, p) { return Play.friendlyUnits(state, p).some(function (i) { return state.objs[i].buffs > 0; }); },
      cands(state, p) { return Play.friendlyUnits(state, p).filter(function (i) { return state.objs[i].buffs > 0; }); },
      prompt(state, spec, item, label, cands) {
        return { tag: "target", src: item.label, prompt: "Spend " + (spec.any ? "buffs" : "a buff") + " (" + label + ")", min: 1, max: spec.any ? cands.length : 1 };
      },
      pay(state, p, picks, spec, item, a, countKey) {
        for (const iid of picks) Flow.spendBuff(state, iid, p);
        a[countKey + "Count"] = picks.length;
      },
    },
    exhaustLegend: {
      canPay(state, p) { const lg = state.objs[state.players[p].legendIid]; return !!(lg && lg.ready); },
      pay(state, p) { state.objs[state.players[p].legendIid].ready = false; },
    },
    xp: {
      canPay(state, p, spec) { return state.players[p].xp >= spec.n; },
      pay(state, p, picks, spec, item) {
        state.players[p].xp -= spec.n;
        RB.FX.opLog(state, item, "resource", state.players[p].name + " spends " + spec.n + " XP (" + item.label + ").");
      },
    },
    recycleTrash: {
      canPay(state, p, spec) { return state.players[p].trash.length >= spec.n; },
      cands(state, p) { return state.players[p].trash.slice(); },
      prompt(state, spec, item, label) {
        return { tag: "target", src: item.label, prompt: "Recycle " + spec.n + " cards from your trash (" + label + ")", min: spec.n, max: spec.n };
      },
      pay(state, p, picks) { Flow.recycleCards(state, picks); },
    },
  };

  Object.assign(Play, {
    stepCosts(state, frame, item, entries, opts) {
      opts = opts || {};
      const a = frame.answers;
      const p = item.controller;
      const label = opts.label || "cost of " + item.label;
      for (const entry of entries) {
        const kind = COST_KINDS[entry.kind];
        if (!kind) throw new Error("unknown cost kind " + entry.kind);
        if (a[entry.key + "Done"]) continue;
        let picks = null;
        if (kind.cands) {
          if (a[entry.key] === undefined) {
            const cands = kind.cands(state, p, entry.spec);
            const pr = kind.prompt(state, entry.spec, item, label, cands);
            if (cands.length < pr.min) return "fail";
            state.pending = Object.assign({ kind: "choose", player: p, cands: cands, frameKey: entry.key }, pr);
            return "wait";
          }
          picks = Array.isArray(a[entry.key]) ? a[entry.key] : [a[entry.key]];
        } else if (!kind.canPay(state, p, entry.spec)) {
          return "fail";
        }
        kind.pay(state, p, picks, entry.spec, item, a, entry.countKey || entry.key);
        a[entry.key + "Done"] = true;
        if (opts.irrevocable) a.irrevocable = true;
      }
      return "ok";
    },

    stepAbilityCosts(state, frame, item) {
      const meta = item.costMeta;
      if (!meta) return true;
      const entries = [];
      if (meta.costDiscard) entries.push({ kind: "discard", spec: { n: meta.costDiscard, type: meta.costDiscardType }, key: "costDiscard" });
      if (meta.costKillFriendly) entries.push({ kind: "kill", spec: { type: "unit" }, key: "costKill" });
      if (meta.costRecycleTrash) entries.push({ kind: "recycleTrash", spec: { n: meta.costRecycleTrash }, key: "costRecycle" });
      if (meta.costXp) entries.push({ kind: "xp", spec: { n: meta.costXp }, key: "costXp" });
      const r = Play.stepCosts(state, frame, item, entries, { irrevocable: true });
      if (r === "fail") {
        RB.FX.opLog(state, item, "resource", item.label + ": its cost cannot be paid - removed.");
        Play.removeChainItem(state, item.id);
        return false;
      }
      return r === "ok";
    },

    stepRepeat(state, frame, item) {
      if (item.costsSettled) return true;
      const rScript = RB.Scripts.forCard(state, item.iid);
      const rCosts = Play.repeatCostsFor(state, item);
      if (!rCosts.length || item.flowPlayed) return true;
      const a = frame.answers;
      const p = item.controller;
      a.repeatIdx = a.repeatIdx || 0;
      a.repeatAccepted = a.repeatAccepted || [];
      while (a.repeatIdx < rCosts.length) {
        const rc = rCosts[a.repeatIdx];
        const key = "repeat" + a.repeatIdx;
        if (a[key] === undefined) {
          if (Play.repeatAffordable(state, item, a, a.repeatIdx)) {
            const bits = [];
            const shown = Play.repeatEntryCost(state, item, rc);
            if (shown.energy) bits.push(shown.energy + " energy");
            if (shown.pips.length) bits.push(shown.pips.length + " " + ((shown.pips[0] || [])[0] || "") + " power");
            if (shown.anyPower) bits.push(shown.anyPower + " any power");
            if (rc.costDiscard) bits.push("discard " + rc.costDiscard + (rc.costDiscardType ? " " + rc.costDiscardType : ""));
            state.pending = {
              kind: "choose", player: p, tag: "may",
              prompt: "Pay the Repeat cost (" + bits.join(" + ") + ") to repeat " + item.label + "?",
              options: ["Yes", "No"], frameKey: key,
            };
            return false;
          }
          a[key] = false;
        }
        if (a[key] === true && rc.costDiscard) {
          const entries = [{ kind: "discard", spec: { n: rc.costDiscard, type: rc.costDiscardType }, key: key + "Picks" }];
          const r = Play.stepCosts(state, frame, item, entries, { irrevocable: true, label: "Repeat cost of " + item.label });
          if (r === "wait") return false;
          if (r === "fail") { a[key] = false; a.repeatIdx++; continue; }
        }
        if (a[key] === true && a.repeatAccepted.indexOf(a.repeatIdx) < 0) a.repeatAccepted.push(a.repeatIdx);
        a.repeatIdx++;
      }
      if (a.repeatAccepted.length && !item.repeatApplied) {
        item.repeatApplied = true;
        const specs = (rScript && rScript.targets) || [];
        const binds = specs.map(function (s) { return s.bind; });
        let extra = [];
        let prog = item.program || [];
        for (let i = 0; i < a.repeatAccepted.length; i++) {
          const suffix = "_r" + i;
          extra = extra.concat(Play.rebindClone(specs, binds, suffix));
          prog = prog.concat(Play.rebindClone((rScript && rScript.play) || [], binds, suffix));
        }
        item.extraTargetSpecs = extra;
        item.program = prog;
      }
      return true;
    },

    repeatAffordable(state, item, a, idx) {
      const rc = Play.repeatCostsFor(state, item)[idx];
      if (!rc) return false;
      if (rc.costDiscard && !Play.canPayDiscard(state, item.controller, rc.costDiscard, rc.costDiscardType)) return false;
      const withThis = Object.assign({}, a, { repeatAccepted: (a.repeatAccepted || []).concat([idx]) });
      const tot = Play.effectiveCost(state, item, withThis);
      return Play.poolPotentialCovers(state, item.controller, tot, Play.payCtxForItem(state, item));
    },

    addCostEntries(state, item) {
      if (item.flowPlayed || item.fromFacedown) return [];
      const script = RB.Scripts.forCard(state, item.iid);
      const own = (script && script.addCosts) || [];
      const auras = Play.auraAddCostEntries(state, item);
      return auras.length ? own.concat(auras) : own;
    },

    auraAddCostEntries(state, item) {
      const out = [];
      const p = item.controller;
      for (const s of Core.ruleSources(state, "auraAddCosts", { legends: true })) {
        for (const entry of s.rule) {
          if (!RB.Scripts.auraMatch(state, entry, s.iid, s.obj, item.iid, null, { p: p, loc: null })) continue;
          out.push(Object.assign({}, entry, { auraSrc: s.iid }));
        }
      }
      return out;
    },

    addCostKillCands(state, p, kill) {
      return Core.boardObjs(state, function (o, i) {
        if (o.controller !== p) return false;
        if (!Core.isType(state, i, kill.type)) return false;
        if (kill.type === "unit" && o.attachedTo) return false;
        if (kill.mighty && (Core.effMight(state, i) || 0) < 5) return false;
        if (kill.tags && !kill.tags.some(function (t) { return Core.hasTag(state, i, t); })) return false;
        return true;
      });
    },

    addCostNonResourceEntries(entry, i) {
      const key = "addCost" + i;
      const out = [];
      if (entry.costDiscard) out.push({ kind: "discard", spec: { n: entry.costDiscard }, key: key + "Discard" });
      if (entry.costKill) out.push({ kind: "kill", spec: Object.assign({ playToPaidBf: entry.playToPaidBf }, entry.costKill), key: key + "Kill", countKey: key });
      if (entry.costReturn) out.push({ kind: "return", spec: entry.costReturn, key: key + "Return" });
      if (entry.costExhaust) out.push({ kind: "exhaust", spec: {}, key: key + "Exhaust" });
      if (entry.costSpendBuff) out.push({ kind: "spendBuff", spec: { any: entry.costSpendBuff === "any" }, key: key + "Buff", countKey: key });
      if (entry.costExhaustLegend) out.push({ kind: "exhaustLegend", spec: {}, key: key + "Legend" });
      if (entry.costXp) out.push({ kind: "xp", spec: { n: entry.costXp }, key: key + "Xp" });
      return out;
    },

    mandatoryAddCostsPayable(state, p, iid, origin) {
      const probe = Play.probeItem(state, p, iid, origin);
      const entries = Play.addCostEntries(state, probe);
      return entries.every(function (entry, i) { return entry.optional || Play.addCostPayable(state, probe, entry, i, {}); });
    },

    addCostPayable(state, item, entry, i, answers) {
      const p = item.controller;
      if (entry.cond && !RB.FX.cond(state, item, entry.cond)) return false;
      const parts = Play.addCostNonResourceEntries(entry, i);
      for (const part of parts) {
        const kind = COST_KINDS[part.kind];
        if (!kind.canPay(state, p, part.spec)) return false;
      }
      if (entry.cost) {
        const withThis = Object.assign({}, answers);
        withThis["addCost" + i] = true;
        const tot = Play.effectiveCost(state, item, withThis);
        if (!Play.poolPotentialCovers(state, p, tot, Play.payCtxForItem(state, item))) return false;
      }
      return true;
    },

    addCostLabel(entry) {
      const bits = [];
      if (entry.cost) {
        if (entry.cost.energy) bits.push(entry.cost.energy + " energy");
        if (entry.cost.pips) bits.push(entry.cost.pips + " " + ((entry.cost.domains || [])[0] || "") + " power");
        if (entry.cost.anyPower) bits.push(entry.cost.anyPower + " any power");
      }
      if (entry.costDiscard) bits.push("discard " + entry.costDiscard);
      if (entry.costXp) bits.push("spend " + entry.costXp + " XP");
      if (entry.costSpendBuff) bits.push(entry.costSpendBuff === "any" ? "spend any number of buffs" : "spend a buff");
      if (entry.costExhaustLegend) bits.push("exhaust your legend");
      if (entry.costExhaust) bits.push("exhaust a friendly unit");
      if (entry.costKill) {
        bits.push("kill " + (entry.costKill.any ? "any number of friendly units"
          : (entry.costKill.tags ? "a " + entry.costKill.tags.join("/") : "a friendly " + entry.costKill.type)));
      }
      if (entry.costReturn) bits.push("return a friendly " + entry.costReturn.type + " to hand");
      return bits.join(" + ");
    },

    stepAddCosts(state, frame, item) {
      if (item.costsSettled) return true;
      const entries = Play.addCostEntries(state, item);
      if (!entries.length) return true;
      const a = frame.answers;
      const p = item.controller;
      const unpayable = function () {
        RB.FX.opLog(state, item, "resource", item.label + ": the additional cost cannot be paid - removed.");
        Play.cancelPlay(state, item);
        return false;
      };
      a.addCostIdx = a.addCostIdx || 0;
      while (a.addCostIdx < entries.length) {
        const i = a.addCostIdx;
        const entry = entries[i];
        const key = "addCost" + i;
        if (a[key] === undefined) {
          const payable = Play.addCostPayable(state, item, entry, i, a);
          if (!payable) {
            if (!entry.optional) return unpayable();
            a[key] = false;
          } else if (entry.optional) {
            state.pending = {
              kind: "choose", player: p, tag: "may",
              prompt: "Pay the additional cost (" + Play.addCostLabel(entry) + ") for " + item.label + "?",
              options: ["Yes", "No"], frameKey: key,
            };
            return false;
          } else {
            a[key] = true;
          }
        }
        if (a[key] !== true) { a.addCostIdx++; continue; }
        if (entry.auraSrc && entry.playToSourceBf && state.battlefields.indexOf(entry.auraSrc) >= 0) {
          item.addCostBf = { t: "bf", iid: entry.auraSrc };
        }
        const r = Play.stepCosts(state, frame, item, Play.addCostNonResourceEntries(entry, i), { irrevocable: true, label: "additional cost of " + item.label });
        if (r === "wait") return false;
        if (r === "fail") return unpayable();
        a.addCostIdx++;
      }
      return true;
    },

    applyAddCostDiscount(state, item, cost, entry, paid, killCost) {
      const doms = Core.card(state, item.iid).domains;
      const cut = function (res, times) {
        const d = Play.costFromRes(res, doms);
        cost.energy = Math.max(0, cost.energy - d.energy * times);
        for (let k = 0; k < d.pips.length * times; k++) if (cost.pips.length) cost.pips.pop();
        cost.anyPower = Math.max(0, cost.anyPower - d.anyPower * times);
      };
      if (entry.discount && entry.discount.all) {
        cost.energy = 0; cost.pips.length = 0; cost.anyPower = 0;
        return;
      }
      if (entry.discount) cut(entry.discount, 1);
      if (entry.discountPerPaid) cut(entry.discountPerPaid, paid || 1);
      if (entry.discountPerKilledCost && killCost) {
        cut(entry.discountPerKilledCost.energy, killCost.energy);
        cut(entry.discountPerKilledCost.power, killCost.power);
      }
    },

    appendAddCostRidersToSpell(state, item, answers) {
      const entries = Play.addCostEntries(state, item);
      const script = RB.Scripts.forCard(state, item.iid);
      entries.forEach(function (entry, i) {
        const paid = answers["addCost" + i] === true;
        const kc = answers["addCost" + i + "KillCost"];
        if (kc) {
          item.vars.killCostEnergy = kc.energy;
          item.vars.killCostPower = kc.power;
        }
        const run = paid ? entry.then : entry.otherwise;
        const specs = paid ? entry.thenTargets : entry.otherwiseTargets;
        if (!run) return;
        const base = item.program || (script && script.play) || [];
        item.program = base.concat(run);
        if (specs && specs.length) {
          item.extraTargetSpecs = (item.extraTargetSpecs || []).concat(specs);
        }
      });
    },

    queueAddCostRiders(state, item, answers) {
      const entries = Play.addCostEntries(state, item);
      const o = state.objs[item.iid];
      const ctxBf = o && o.loc && o.loc.t === "bf" ? o.loc.iid : null;
      entries.forEach(function (entry, i) {
        const paid = answers["addCost" + i] === true;
        const run = paid ? entry.then : entry.otherwise;
        if (!run) return;
        state.triggerQueue.push({
          controller: item.controller,
          source: item.iid,
          label: Core.name(state, item.iid) + ": additional cost effect",
          program: run,
          targetSpecs: (paid ? entry.thenTargets : entry.otherwiseTargets) || [],
          ctx: { bf: ctxBf },
        });
      });
    },

    effectiveCost(state, item, a) {
      a = a || {};
      const allTargets = [];
      for (const b in item.targets) {
        for (const t of item.targets[b]) allTargets.push(t);
      }
      const dsc = item.iid ? RB.Scripts.forCard(state, item.iid) : null;
      const deflect = dsc && dsc.ignoreDeflect
        ? 0 : Play.deflectSurcharge(state, item.controller, allTargets);
      let cost;
      if (item.kind === "ability") {
        const base = item.cost || { energy: 0, pips: [], anyPower: 0 };
        cost = { energy: base.energy, pips: base.pips.slice(), anyPower: base.anyPower + deflect };
        if (item.energyLessByTargetMight) {
          const tref = (item.targets[item.energyLessByTargetMight] || [])[0];
          const tm = tref ? Core.effMight(state, tref) : 0;
          cost.energy = Math.max(0, cost.energy - (tm || 0));
        }
        return cost;
      }
      if (item.flowPlayed) {
        cost = Play.flowCardCost(state, item.iid);
        cost.anyPower += deflect;
        for (const m of Play.costModsFor(state, item.iid, item.controller, item, "trash")) {
          Play.applyCostMod(state, cost, m, item.iid, item.controller);
        }
      } else {
        const iopts = item.opts || {};
        cost = Play.cardCost(state, item.iid, {
          item: item,
          fromZone: item.fromFacedown ? "facedown" : (item.fromZone || "hand"),
          accelerate: a.accelerate,
          ignoreBase: item.fromFacedown,
          deflectCount: deflect,
          controller: item.controller,
          waiveAll: iopts.waive === "all",
          waiveEnergy: iopts.waive === "energy",
          energyLess: iopts.energyLess || 0,
        });
      }
      const doms = Core.card(state, item.iid).domains;
      const addMods = Play.auraCostModsFlagged(state, item.controller, "addCost");
      const addRes = function (res, discountable) {
        const rc = Play.costFromRes(res, doms);
        if (discountable) for (const m of addMods) Play.applyCostMod(state, rc, m, item.iid, item.controller);
        cost = Play.sumCosts(cost, rc);
      };
      if (a.accelerate && addMods.length) {
        const acc = { energy: 1, pips: [Core.pipDomains(doms)], anyPower: 0 };
        for (const m of addMods) Play.applyCostMod(state, acc, m, item.iid, item.controller);
        cost.energy = Math.max(0, cost.energy - (1 - acc.energy));
        for (let i = acc.pips.length; i < 1; i++) if (cost.pips.length) cost.pips.pop();
      }
      if (a.repeatAccepted && a.repeatAccepted.length) {
        const rEntries = Play.repeatCostsFor(state, item);
        const rMods = Play.auraCostModsFlagged(state, item.controller, "repeat");
        for (const idx of a.repeatAccepted) {
          if (!rEntries[idx]) continue;
          const rc = Play.repeatEntryCost(state, item, rEntries[idx]);
          for (const m of rMods) Play.applyCostMod(state, rc, m, item.iid, item.controller);
          cost = Play.sumCosts(cost, rc);
        }
      }
      const addEntries = Play.addCostEntries(state, item);
      for (let i = 0; i < addEntries.length; i++) {
        if (a["addCost" + i] !== true) continue;
        const entry = addEntries[i];
        if (entry.cost) addRes(entry.cost, !!entry.optional);
        Play.applyAddCostDiscount(state, item, cost, entry, a["addCost" + i + "Count"] || 1, a["addCost" + i + "KillCost"]);
      }
      return cost;
    },

    stepPayment(state, frame, item) {
      const a = frame.answers;
      if (a.paid || item.costsSettled) return true;
      const cost = Play.effectiveCost(state, item, a);
      if (Play.costFree(cost)) {
        a.paid = true;
        return true;
      }
      state.pending = {
        kind: "pay", player: item.controller, cost: cost,
        payCtx: Play.payCtxForItem(state, item),
        note: "Pay for " + item.label,
        cancellable: item.kind !== "trigger" && !a.irrevocable,
      };
      return false;
    },

    sumCosts(a, b) {
      return { energy: a.energy + b.energy, pips: a.pips.concat(b.pips), anyPower: a.anyPower + b.anyPower };
    },

    costFree(cost) {
      return !cost.energy && !cost.pips.length && !cost.anyPower;
    },

    discardableHand(state, p, type) {
      return state.players[p].hand.filter(function (i) { return !type || Core.isType(state, i, type); });
    },

    canPayDiscard(state, p, n, type) {
      return Play.discardableHand(state, p, type).length >= n;
    },

    friendlyUnits(state, p) {
      return Core.boardObjs(state, function (o, i) {
        return o.controller === p && Core.isType(state, i, "unit") && !o.attachedTo;
      });
    },

    canPayKillFriendly(state, p) {
      return Play.friendlyUnits(state, p).length > 0;
    },

    exhaustCostPayable(state, item) {
      const src = item.source && state.objs[item.source];
      if (!src || !src.ready) return false;
      if (src.zone !== "board" && src.zone !== "legendZone") return false;
      return !state.chain.some(function (it) {
        return it.id !== item.id && it.exhaustSelfClaimed && it.source === item.source;
      });
    },
  });
})();
